/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundHistoryDtoWithdraw
 */
export interface FundHistoryDtoWithdraw {
  /**
   *
   * @type {string}
   * @memberof FundHistoryDtoWithdraw
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof FundHistoryDtoWithdraw
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof FundHistoryDtoWithdraw
   */
  createdAt: Date;
}

export function FundHistoryDtoWithdrawFromJSON(json: any): FundHistoryDtoWithdraw {
  return FundHistoryDtoWithdrawFromJSONTyped(json, false);
}

export function FundHistoryDtoWithdrawFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundHistoryDtoWithdraw {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
  };
}

export function FundHistoryDtoWithdrawToJSON(value?: FundHistoryDtoWithdraw | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
  };
}
